// create a container and set the full-size image as its background
function createOverlay(image, last) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', last.src);
  console.log("Image " + image.src);
  //console.log("Last " + last.src);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, last) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = 'url(' + last.src + ')';
  container.style.opacity = '50%';

  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function magnify(image, last) {
  const overlay = createOverlay(image, last);
  overlay.onclick = () => overlay.remove();
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover() {
  const images = document.querySelectorAll('.image-magnify-hover');
  const last = images[images.length- 1];
  const product_info = document.getElementsByTagName('product-info')[0];
  //const product_info = document.getElementsByName('product-info')[0];
  const product_name = product_info.getAttribute('data-product-name');

  console.log("Product: " + product_name);
  images.forEach((image) => {
    image.onmousemove = (event) => {
      magnify(image, last); 
    };
  });
}

enableZoomOnHover();
